import { createContext, useCallback, useContext, useState } from 'react';
import type { JSX, PropsWithChildren } from 'react';

const PublicFieldValueContext = createContext<boolean>(true);
const SetPublicFieldValueContext = createContext<(value: boolean) => void>(() => undefined);

export function PublicFieldContextProvider({ children }: PropsWithChildren): JSX.Element {
	const [publicValue, setPublicValue] = useState<boolean>(true);
	const setter = useCallback((value: boolean) => setPublicValue(value), []);

	return (
		<PublicFieldValueContext.Provider value={publicValue}>
			<SetPublicFieldValueContext.Provider value={setter}>{children}</SetPublicFieldValueContext.Provider>
		</PublicFieldValueContext.Provider>
	);
}

export function usePublicFieldValue(): boolean {
	return useContext(PublicFieldValueContext);
}

export function useSetPublicFieldValue(): (value: boolean) => void {
	return useContext(SetPublicFieldValueContext);
}
